import React from "react";
import Grid from "@mui/material/Grid2";

const QuestionGroup = ({ question, isVisible, renderField }) => {
  const visibleFields = question.fields.filter(subq => isVisible(subq));
  if (question.separator) {
    return (
      <Grid container spacing={2} alignItems="center" justifyContent="flex-start">
        {visibleFields.map((subq, index) => (
          <React.Fragment key={subq.id}>
            <Grid item>
              { renderField(subq) }
            </Grid>
            {index < visibleFields.length - 1 && (
              <Grid item>
                <div style={{ opacity: 0.5 }}>{question.separator}</div>
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    );
  }
  const nonSeparatorCount = visibleFields.filter(f => f.field_type !== "separator").length;
  return (
    <Grid container spacing={2} direction="row" alignItems="center" justifyContent="flex-start">
      {visibleFields.map(subq => (
        <Grid key={subq.id} item size={Math.floor(12 / nonSeparatorCount)}>
          { renderField(subq) }
        </Grid>
      ))}
    </Grid>
  );
};

export default QuestionGroup;
